

// import React, { useState, useMemo, useRef, useEffect } from 'react';
// import '../styles/OfficeRequisition.css';

// const OfficeRequisition = ({ userData }) => {

//   const [history, setHistory] = useState([]);
//   const [loadingHistory, setLoadingHistory] = useState(true);

//   const [category, setCategory] = useState("");
//   const [item, setItem] = useState("");
//   const [amount, setAmount] = useState("");
//   const [expenseDate, setExpenseDate] = useState("");
//   const [remarks, setRemarks] = useState("");
//   const [receipt, setReceipt] = useState(null);
//   const [isSubmitting, setIsSubmitting] = useState(false);
//   const inputRef = useRef(null);

//   const ticketInfo = useMemo(() => ({
//     reqId: `EXP-${Math.floor(5000 + Math.random() * 4000)}`,
//     date: new Date().toLocaleDateString('en-GB'),
//   }), []);

//   const handleSubmit = async (e) => {
//     e.preventDefault();

//     if (!receipt) {
//       alert("Please upload receipt.");
//       return;
//     }

//     setIsSubmitting(true);

//     const formData = new FormData();

//     formData.append("req_id", ticketInfo.reqId);
//     formData.append("emp_id", userData?.id);
//     formData.append("employee_name", `${userData?.firstName} ${userData?.lastName}`);
//     formData.append("department", userData?.dept || userData?.Department);

//     formData.append("category", category);
//     formData.append("item_name", item);
//     formData.append("amount", amount);
//     formData.append("expense_date", expenseDate);
//     formData.append("remarks", remarks);
//     formData.append("status", "PENDING");

//     formData.append("receipt", receipt);

//     try {

//       const response = await fetch("/gt-api/save_reimbursement.php", {
//         method: "POST",
//          credentials: "include",
//         body: formData
//       });

//       const result = await response.json();

//       if (result.success) {

//         alert(`SUCCESS: Expense ${ticketInfo.reqId} sent to management.`);

//         setItem("");
//         setCategory("");
//         setAmount("");
//         setExpenseDate("");
//         setRemarks("");
//         setReceipt(null);

//       } else {
//         alert("Error: " + result.message);
//       }

//     } catch (error) {

//       console.error(error);
//       alert("System Offline: Management could not be reached.");

//     } finally {
//       setIsSubmitting(false);
//     }
//   };

//   useEffect(() => {
//     const fetchHistory = async () => {
//       try {
//         const res = await fetch(
//           `/gt-api/get_reimbursement_history.php?empid=${userData?.id}`
//           , { credentials: "include" }
//         );

//         const data = await res.json();

//         if (data.success) {
//           setHistory(data.records);
//         } else {
//           console.error("Failed to fetch history");
//         }

//       } catch (err) {
//         console.error(err);
//       } finally {
//         setLoadingHistory(false);
//       }
//     };

//     if (userData?.id) {
//       fetchHistory();
//     }
//   }, [userData]);
//   return (
//     <div className="requisition-wrapper animate-fade">
//       <div className="req-card glass">

//         {/* ================= HEADER ================= */}
//         <div className="form-header-main">
//           <div className="header-icon">💰</div>
//           <div className="header-titles">
//             <h2>EXPENSE_REIMBURSEMENT</h2>
//             <p>Expense Ticket: {ticketInfo.reqId}</p>
//           </div>
//         </div>

//         {/* ================= FORM ================= */}
//         <form className="cyber-form-layout" onSubmit={handleSubmit}>

//           {/* EMPLOYEE DETAILS */}
//           <div className="form-sub-label">EMPLOYEE_DETAILS</div>

//           <div className="readonly-grid">
//             <div className="form-group">
//               <label>EXPENSE ID</label>
//               <input value={ticketInfo.reqId} readOnly className="read-only-input" />
//             </div>

//             <div className="form-group">
//               <label>REQUEST DATE</label>
//               <input value={ticketInfo.date} readOnly className="read-only-input" />
//             </div>

//             <div className="form-group">
//               <label>EMPLOYEE</label>
//               <input
//                 value={`${userData?.firstName || ''} ${userData?.lastName || ''}`}
//                 readOnly
//                 className="read-only-input"
//               />
//             </div>

//             <div className="form-group">
//               <label>DEPARTMENT</label>
//               <input
//                 value={userData?.dept || userData?.Department || 'General'}
//                 readOnly
//                 className="read-only-input"
//               />
//             </div>
//           </div>

//           <div className="cyber-divider" />

//           {/* EXPENSE DETAILS */}
//           <div className="form-sub-label">EXPENSE_DETAILS</div>

//           <div className="editable-grid">

//             {/* CATEGORY */}
//             <div className="form-group">
//               <label>EXPENSE CATEGORY</label>
//               <select
//                 value={category}
//                 onChange={(e) => setCategory(e.target.value)}
//                 className="theme-select-field"
//                 required
//               >
//                 <option value="" disabled>Select category...</option>
//                 <option value="Travel">Travel</option>
//                 <option value="Food">Food</option>
//                 <option value="Accomodation">Accomodation</option>
//                 <option value="Entertainment">Entertainment</option>
//                 <option value="Office Supplies & Equipments">Office Supplies & Equipments</option>
//                 <option value="Professional Development">Professional Development</option>
//                 <option value="Medical & Wellness">Medical & Wellness</option>
//                 <option value="Miscelleneous Expense">Miscelleneous Expense</option>
//               </select>
//             </div>

//             {/* ITEM */}
//             <div className="form-group">
//               <label>ITEM / DESCRIPTION</label>
//               <input
//                 type="text"
//                 className="theme-text-input"
//                 value={item}
//                 onChange={(e) => setItem(e.target.value)}
//                 placeholder="Example: Uber Ride / Printer Ink"
//                 required
//               />
//             </div>

//             {/* AMOUNT */}
//             <div className="form-group">
//               <label>AMOUNT (₹)</label>
//               <input
//                 type="number"
//                 className="theme-text-input"
//                 value={amount}
//                 onChange={(e) => setAmount(e.target.value)}
//                 placeholder="Enter amount"
//                 required
//               />
//             </div>

//             {/* DATE */}
//             <div className="form-group">
//               <label>EXPENSE DATE</label>
//               <div style={{ position: "relative" }}>
//                 <input
//                   ref={inputRef}
//                   type="date"
//                   className="theme-text-input"
//                   value={expenseDate}
//                   onChange={(e) => setExpenseDate(e.target.value)}
//                   style={{ paddingRight: "40px" }}
//                   required
//                 />
//                 <span
//                   onClick={() => inputRef.current?.showPicker?.() || inputRef.current?.click()}
//                   style={{
//                     position: "absolute",
//                     right: "10px",
//                     top: "50%",
//                     transform: "translateY(-50%)",
//                     cursor: "pointer"
//                   }}
//                 >
//                   📅
//                 </span>
//               </div>
//             </div>

//             {/* RECEIPT */}
//             <div className="form-group full-row">
//               <label>UPLOAD RECEIPT</label>
//               <input
//                 type="file"
//                 accept=".jpg,.png,.pdf"
//                 className="theme-text-input"
//                 onChange={(e) => setReceipt(e.target.files[0])}
//                 required
//               />
//             </div>

//             {/* REMARKS */}
//             <div className="form-group full-row">
//               <label>REMARKS</label>
//               <textarea
//                 className="theme-textarea"
//                 value={remarks}
//                 onChange={(e) => setRemarks(e.target.value)}
//                 placeholder="Optional explanation..."
//               />
//             </div>

//           </div>

//           {/* BUTTONS */}
//           <div className="form-footer-actions">
//             <button type="submit" className="btn-submit-cyber" disabled={isSubmitting}>
//               {isSubmitting ? "SUBMITTING..." : "SUBMIT EXPENSE"}
//             </button>

//             <button
//               type="button"
//               className="btn-abort-cyber"
//               onClick={() => {
//                 setItem("");
//                 setCategory("");
//                 setAmount("");
//                 setExpenseDate("");
//                 setRemarks("");
//                 setReceipt(null);
//               }}
//             >
//               RESET
//             </button>
//           </div>

//         </form>

//         {/* ================= HISTORY ================= */}
//         <div className="reimb-history-section">
//           <h3 className="reimb-history-title">📜 REIMBURSEMENT HISTORY</h3>

//           {loadingHistory ? (
//             <p className="reimb-history-loading">Loading...</p>
//           ) : history.length === 0 ? (
//             <p className="reimb-history-empty">No records found.</p>
//           ) : (
//             <div style={{ maxHeight: "320px", overflowY: "auto" }}>
//               <div className="reimb-history-container">
//                 <table className="reimb-history-table">

//                   <thead>
//                     <tr>
//                       <th>Req ID</th>
//                       <th>Date</th>
//                       <th>Category</th>
//                       <th>Item</th>
//                       <th>Amount</th>
//                       <th>Status</th>
//                     </tr>
//                   </thead>

//                   <tbody>
//                     {history.map((row, index) => (
//                       <tr key={index}>

//                         <td className="reimb-id">{row.req_id}</td>

//                         <td>{row.expense_date}</td>

//                         <td className="reimb-category">
//                           {row.category}
//                         </td>

//                         <td className="reimb-item">
//                           {row.item_name}
//                         </td>

//                         <td className="reimb-amount">
//                           ₹{row.amount}
//                         </td>

//                         <td className="reimb-status-cell">
//                           <span className={`reimb-status-badge reimb-status-${row.status.toLowerCase()}`}>
//                             {row.status}
//                           </span>
//                         </td>

//                       </tr>
//                     ))}
//                   </tbody>

//                 </table>
//               </div>
//             </div>
//           )}
//         </div>

//       </div>
//     </div>
//   );
// };

// export default OfficeRequisition;






















// import React, { useState, useMemo, useRef, useEffect } from 'react';
// import '../styles/OfficeRequisition.css';

// const OfficeRequisition = ({ userData }) => {

//   const [history, setHistory] = useState([]);
//   const [loadingHistory, setLoadingHistory] = useState(true);

//   const [category, setCategory] = useState("");
//   const [item, setItem] = useState("");
//   const [amount, setAmount] = useState("");
//   const [expenseDate, setExpenseDate] = useState("");
//   const [remarks, setRemarks] = useState("");
//   const [receipt, setReceipt] = useState(null);
//   const [isSubmitting, setIsSubmitting] = useState(false);
//   const inputRef = useRef(null);

//   const ticketInfo = useMemo(() => ({
//     reqId: `EXP-${Math.floor(5000 + Math.random() * 4000)}`,
//     date: new Date().toLocaleDateString('en-GB'),
//   }), []);

//   const handleSubmit = async (e) => {
//     e.preventDefault();

//     if (!receipt) {
//       alert("Please upload receipt.");
//       return;
//     }

//     setIsSubmitting(true);

//     const formData = new FormData();

//     formData.append("req_id", ticketInfo.reqId);
//     formData.append("emp_id", userData?.id);
//     formData.append("employee_name", `${userData?.firstName} ${userData?.lastName}`);
//     formData.append("department", userData?.dept || userData?.Department);

//     formData.append("category", category);
//     formData.append("item_name", item);
//     formData.append("amount", amount);
//     formData.append("expense_date", expenseDate);
//     formData.append("remarks", remarks);
//     formData.append("status", "PENDING");

//     formData.append("receipt", receipt);

//     try {

//       const response = await fetch("/gt-api/save_reimbursement.php", {
//         method: "POST",
//         credentials: "include",
//         body: formData
//       });

//       const result = await response.json();

//       if (result.success) {

//         alert(`SUCCESS: Expense ${ticketInfo.reqId} sent to management.`);

//         setItem("");
//         setCategory("");
//         setAmount("");
//         setExpenseDate("");
//         setRemarks("");
//         setReceipt(null);

//       } else {
//         alert("Error: " + result.message);
//       }

//     } catch (error) {

//       console.error(error);
//       alert("System Offline: Management could not be reached.");

//     } finally {
//       setIsSubmitting(false);
//     }
//   };

//   useEffect(() => {
//     const fetchHistory = async () => {
//       try {
//         const res = await fetch(
//           `/gt-api/get_reimbursement_history.php?empid=${userData?.id}`
//           , { credentials: "include" }
//         );

//         const data = await res.json();

//         if (data.success) {
//           setHistory(data.records);
//         } else {
//           console.error("Failed to fetch history");
//         }

//       } catch (err) {
//         console.error(err);
//       } finally {
//         setLoadingHistory(false);
//       }
//     };

//     if (userData?.id) {
//       fetchHistory();
//     }
//   }, [userData]);
//   return (
//     <div className="requisition-wrapper animate-fade">
//       <div className="req-card glass">

//         {/* ================= HEADER ================= */}
//         <div className="form-header-main">
//           <div className="header-icon">💰</div>
//           <div className="header-titles">
//             <h2>EXPENSE_REIMBURSEMENT</h2>
//             <p>Expense Ticket: {ticketInfo.reqId}</p>
//           </div>
//         </div>

//         {/* ================= FORM ================= */}
//         <form className="cyber-form-layout" onSubmit={handleSubmit}>

//           {/* EMPLOYEE DETAILS */}
//           <div className="form-sub-label">EMPLOYEE_DETAILS</div>

//           <div className="readonly-grid">
//             <div className="form-group">
//               <label>EXPENSE ID</label>
//               <input value={ticketInfo.reqId} readOnly className="read-only-input" />
//             </div>

//             <div className="form-group">
//               <label>REQUEST DATE</label>
//               <input value={ticketInfo.date} readOnly className="read-only-input" />
//             </div>

//             <div className="form-group">
//               <label>EMPLOYEE</label>
//               <input
//                 value={`${userData?.firstName || ''} ${userData?.lastName || ''}`}
//                 readOnly
//                 className="read-only-input"
//               />
//             </div>

//             <div className="form-group">
//               <label>DEPARTMENT</label>
//               <input
//                 value={userData?.dept || userData?.Department || 'General'}
//                 readOnly
//                 className="read-only-input"
//               />
//             </div>
//           </div>

//           <div className="cyber-divider" />

//           {/* EXPENSE DETAILS */}
//           <div className="form-sub-label">EXPENSE_DETAILS</div>

//           <div className="editable-grid">

//             {/* CATEGORY */}
//             <div className="form-group">
//               <label>EXPENSE CATEGORY</label>
//               <select
//                 value={category}
//                 onChange={(e) => setCategory(e.target.value)}
//                 className="theme-select-field"
//                 required
//               >
//                 <option value="" disabled>Select category...</option>
//                 <option value="Travel">Travel</option>
//                 <option value="Food">Food</option>
//                 <option value="Accomodation">Accomodation</option>
//                 <option value="Entertainment">Entertainment</option>
//                 <option value="Office Supplies & Equipments">Office Supplies & Equipments</option>
//                 <option value="Professional Development">Professional Development</option>
//                 <option value="Medical & Wellness">Medical & Wellness</option>
//                 <option value="Miscelleneous Expense">Miscelleneous Expense</option>
//               </select>
//             </div>

//             {/* ITEM */}
//             <div className="form-group">
//               <label>ITEM / DESCRIPTION</label>
//               <input
//                 type="text"
//                 className="theme-text-input"
//                 value={item}
//                 onChange={(e) => setItem(e.target.value)}
//                 placeholder="Example: Uber Ride / Printer Ink"
//                 required
//               />
//             </div>

//             {/* AMOUNT */}
//             <div className="form-group">
//               <label>AMOUNT (₹)</label>
//               <input
//                 type="number"
//                 className="theme-text-input"
//                 value={amount}
//                 onChange={(e) => setAmount(e.target.value)}
//                 placeholder="Enter amount"
//                 required
//               />
//             </div>

//             {/* DATE */}
//             <div className="form-group">
//               <label>EXPENSE DATE</label>

//               <div className="expense-date-wrapper">
//                 <input
//                   ref={inputRef}
//                   type="date"
//                   className="theme-text-input expense-date-input"
//                   value={expenseDate}
//                   onChange={(e) => setExpenseDate(e.target.value)}
//                   required
//                 />

//                 <span
//                   className="expense-date-icon"
//                   onClick={() => inputRef.current?.showPicker?.() || inputRef.current?.click()}
//                 >
//                   📅
//                 </span>
//               </div>
//             </div>

//             {/* RECEIPT */}
//             <div className="form-group full-row">
//               <label>UPLOAD RECEIPT</label>
//               <input
//                 type="file"
//                 accept=".jpg,.png,.pdf"
//                 className="theme-text-input"
//                 onChange={(e) => setReceipt(e.target.files[0])}
//                 required
//               />
//             </div>

//             {/* REMARKS */}
//             <div className="form-group full-row">
//               <label>REMARKS</label>
//               <textarea
//                 className="theme-textarea"
//                 value={remarks}
//                 onChange={(e) => setRemarks(e.target.value)}
//                 placeholder="Optional explanation..."
//               />
//             </div>

//           </div>

//           {/* BUTTONS */}
//           <div className="form-footer-actions">
//             <button type="submit" className="btn-submit-cyber" disabled={isSubmitting}>
//               {isSubmitting ? "SUBMITTING..." : "SUBMIT EXPENSE"}
//             </button>

//             <button
//               type="button"
//               className="btn-abort-cyber"
//               onClick={() => {
//                 setItem("");
//                 setCategory("");
//                 setAmount("");
//                 setExpenseDate("");
//                 setRemarks("");
//                 setReceipt(null);
//               }}
//             >
//               RESET
//             </button>
//           </div>

//         </form>

//         {/* ================= HISTORY ================= */}
//         <div className="reimb-history-section">
//           <h3 className="reimb-history-title">📜 REIMBURSEMENT HISTORY</h3>

//           {loadingHistory ? (
//             <p className="reimb-history-loading">Loading...</p>
//           ) : history.length === 0 ? (
//             <p className="reimb-history-empty">No records found.</p>
//           ) : (
//             <div style={{ maxHeight: "320px", overflowY: "auto" }}>
//               <div className="reimb-history-container">
//                 <table className="reimb-history-table">

//                   <thead>
//                     <tr>
//                       <th>Req ID</th>
//                       <th>Date</th>
//                       <th>Category</th>
//                       <th>Item</th>
//                       <th>Amount</th>
//                       <th>Status</th>
//                     </tr>
//                   </thead>

//                   <tbody>
//                     {history.map((row, index) => (
//                       <tr key={index}>

//                         <td className="reimb-id">{row.req_id}</td>

//                         <td>{row.expense_date}</td>

//                         <td className="reimb-category">
//                           {row.category}
//                         </td>

//                         <td className="reimb-item">
//                           {row.item_name}
//                         </td>

//                         <td className="reimb-amount">
//                           ₹{row.amount}
//                         </td>

//                         <td className="reimb-status-cell">
//                           <span className={`reimb-status-badge reimb-status-${row.status.toLowerCase()}`}>
//                             {row.status}
//                           </span>
//                         </td>

//                       </tr>
//                     ))}
//                   </tbody>

//                 </table>
//               </div>
//             </div>
//           )}
//         </div>

//       </div>
//     </div>
//   );
// };

// export default OfficeRequisition;




















import React, { useState, useMemo, useRef, useEffect } from 'react';
import '../styles/OfficeRequisition.css';

const OfficeRequisition = ({ userData }) => {

  const [history, setHistory] = useState([]);
  const [loadingHistory, setLoadingHistory] = useState(true);

  const [category, setCategory] = useState("");
  const [item, setItem] = useState("");
  const [amount, setAmount] = useState("");
  const [expenseDate, setExpenseDate] = useState("");
  const [remarks, setRemarks] = useState("");
  const [receipt, setReceipt] = useState(null);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const inputRef = useRef(null);

  const ticketInfo = useMemo(() => ({
    reqId: `EXP-${Math.floor(5000 + Math.random() * 4000)}`,
    date: new Date().toLocaleDateString('en-GB'),
  }), []);

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!receipt) {
      alert("Please upload receipt.");
      return;
    }

    setIsSubmitting(true);

    const formData = new FormData();

    formData.append("req_id", ticketInfo.reqId);
    formData.append("emp_id", userData?.id);
    formData.append("employee_name", `${userData?.firstName} ${userData?.lastName}`);
    formData.append("department", userData?.dept || userData?.Department);

    formData.append("category", category);
    formData.append("item_name", item);
    formData.append("amount", amount);
    formData.append("expense_date", expenseDate);
    formData.append("remarks", remarks);
    formData.append("status", "PENDING");

    formData.append("receipt", receipt);

    try {

      const response = await fetch("/gt-api/save_reimbursement.php", {
        method: "POST",
        credentials: "include",
        body: formData
      });

      const result = await response.json();

      if (result.success) {

        alert(`SUCCESS: Expense ${ticketInfo.reqId} sent to management.`);

        setItem("");
        setCategory("");
        setAmount("");
        setExpenseDate("");
        setRemarks("");
        setReceipt(null);

      } else {
        alert("Error: " + result.message);
      }

    } catch (error) {

      console.error(error);
      alert("System Offline: Management could not be reached.");

    } finally {
      setIsSubmitting(false);
    }
  };

  useEffect(() => {
    const fetchHistory = async () => {
      try {
        const res = await fetch(
          `/gt-api/get_reimbursement_history.php?empid=${userData?.id}`
          , { credentials: "include" }
        );

        const data = await res.json();

        if (data.success) {
          setHistory(data.records);
        } else {
          console.error("Failed to fetch history");
        }

      } catch (err) {
        console.error(err);
      } finally {
        setLoadingHistory(false);
      }
    };

    if (userData?.id) {
      fetchHistory();
    }
  }, [userData]);
  return (
    <div className="requisition-wrapper animate-fade">
      <div className="req-card glass">

        {/* ================= HEADER ================= */}
        <div className="form-header-main">
          <div className="header-icon">💰</div>
          <div className="header-titles">
            <h2>EXPENSE_REIMBURSEMENT</h2>
            <p>Expense Ticket: {ticketInfo.reqId}</p>
          </div>
        </div>

        {/* ================= FORM ================= */}
        <form className="cyber-form-layout" onSubmit={handleSubmit}>

          {/* EMPLOYEE DETAILS */}
          <div className="form-sub-label">EMPLOYEE_DETAILS</div>

          <div className="readonly-grid">
            <div className="form-group">
              <label>EXPENSE ID</label>
              <input value={ticketInfo.reqId} readOnly className="read-only-input" />
            </div>

            <div className="form-group">
              <label>REQUEST DATE</label>
              <input value={ticketInfo.date} readOnly className="read-only-input" />
            </div>

            <div className="form-group">
              <label>EMPLOYEE</label>
              <input
                value={`${userData?.firstName || ''} ${userData?.lastName || ''}`}
                readOnly
                className="read-only-input"
              />
            </div>

            <div className="form-group">
              <label>DEPARTMENT</label>
              <input
                value={userData?.dept || userData?.Department || 'General'}
                readOnly
                className="read-only-input"
              />
            </div>
          </div>

          <div className="cyber-divider" />

          {/* EXPENSE DETAILS */}
          <div className="form-sub-label">EXPENSE_DETAILS</div>

          <div className="editable-grid">

            {/* CATEGORY */}
            <div className="form-group">
              <label>EXPENSE CATEGORY</label>
              <select
                value={category}
                onChange={(e) => setCategory(e.target.value)}
                className="theme-select-field"
                required
              >
                <option value="" disabled>Select category...</option>
                <option value="Travel">Travel</option>
                <option value="Food">Food</option>
                <option value="Accomodation">Accomodation</option>
                <option value="Entertainment">Entertainment</option>
                <option value="Office Supplies & Equipments">Office Supplies & Equipments</option>
                <option value="Professional Development">Professional Development</option>
                <option value="Medical & Wellness">Medical & Wellness</option>
                <option value="Miscelleneous Expense">Miscelleneous Expense</option>
              </select>
            </div>

            {/* ITEM */}
            <div className="form-group">
              <label>ITEM / DESCRIPTION</label>
              <input
                type="text"
                className="theme-text-input"
                value={item}
                onChange={(e) => setItem(e.target.value)}
                placeholder="Example: Uber Ride / Printer Ink"
                required
              />
            </div>

            {/* AMOUNT */}
            <div className="form-group">
              <label>AMOUNT (₹)</label>
              <input
                type="number"
                className="theme-text-input"
                value={amount}
                onChange={(e) => setAmount(e.target.value)}
                placeholder="Enter amount"
                required
              />
            </div>

            {/* DATE */}
            <div className="form-group">
              <label>EXPENSE DATE</label>

              <div className="expense-date-wrapper">
                <input
                  ref={inputRef}
                  type="date"
                  className="theme-text-input expense-date-input"
                  value={expenseDate}
                  onChange={(e) => setExpenseDate(e.target.value)}
                  required
                />

                <span
                  className="expense-date-icon"
                  onClick={() => inputRef.current?.showPicker?.() || inputRef.current?.click()}
                >
                  📅
                </span>
              </div>
            </div>

            {/* RECEIPT */}
            <div className="form-group full-row">
              <label>UPLOAD RECEIPT</label>
              <input
                type="file"
                accept=".jpg,.png,.pdf"
                className="theme-text-input"
                onChange={(e) => setReceipt(e.target.files[0])}
                required
              />
            </div>

            {/* REMARKS */}
            <div className="form-group full-row">
              <label>REMARKS</label>
              <textarea
                className="theme-textarea"
                value={remarks}
                onChange={(e) => setRemarks(e.target.value)}
                placeholder="Optional explanation..."
              />
            </div>

          </div>

          {/* BUTTONS */}
          <div className="form-footer-actions">
            <button type="submit" className="btn-submit-cyber" disabled={isSubmitting}>
              {isSubmitting ? "SUBMITTING..." : "SUBMIT EXPENSE"}
            </button>

            <button
              type="button"
              className="btn-abort-cyber"
              onClick={() => {
                setItem("");
                setCategory("");
                setAmount("");
                setExpenseDate("");
                setRemarks("");
                setReceipt(null);
              }}
            >
              RESET
            </button>
          </div>

        </form>

        {/* ================= HISTORY ================= */}
        <div className="reimb-history-section">
          <h3 className="reimb-history-title">📜 REIMBURSEMENT HISTORY</h3>

          {loadingHistory ? (
            <p className="reimb-history-loading">Loading...</p>
          ) : history.length === 0 ? (
            <p className="reimb-history-empty">No records found.</p>
          ) : (
            <div style={{ maxHeight: "320px", overflowY: "auto" }}>
              <div className="reimb-history-container">
                <table className="reimb-history-table">

                  <thead>
                    <tr>
                      <th>Req ID</th>
                      <th>Date</th>
                      <th>Category</th>
                      <th>Item</th>
                      <th>Amount</th>
                      <th>Status</th>
                    </tr>
                  </thead>

                  <tbody>
                    {history.map((row, index) => (
                      <tr key={index}>

                        <td className="reimb-id">{row.req_id}</td>

                        <td>{row.expense_date}</td>

                        <td className="reimb-category">
                          {row.category}
                        </td>

                        <td className="reimb-item">
                          {row.item_name}
                        </td>

                        <td className="reimb-amount">
                          ₹{row.amount}
                        </td>

                        <td className="reimb-status-cell">
                          <span className={`reimb-status-badge reimb-status-${row.status.toLowerCase()}`}>
                            {row.status}
                          </span>
                        </td>

                      </tr>
                    ))}
                  </tbody>

                </table>
              </div>
            </div>
          )}
        </div>

      </div>
    </div>
  );
};

export default OfficeRequisition;